import { SelectItem, TmdxSelect } from '@ds';
import { SelectItemType } from '@/types';
import { CoverageRenderValue } from './CoverageRenderValue';

export interface CoverageSelectProps {
  items: SelectItemType[];
  value: string[];
  onSelectionChange: (keys: Iterable<string | number>) => void;
  onRemove: (value: string) => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
  errorMessage?: string;
  disabledKeys?: Iterable<string | number>;
  searchValue?: string;
  onSearchValue?: (value: string) => void;
  'aria-label': string;
}

export const CoverageSelect = ({
  items,
  value,
  onSelectionChange,
  onRemove,
  isDisabled,
  isInvalid,
  errorMessage,
  disabledKeys,
  searchValue,
  onSearchValue,
  ...props
}: CoverageSelectProps) => {
  const hasAllOption = items.some((item) => item.value === 'All');
  const allOtherKeys = items.filter((item) => item.value !== 'All').map((item) => item.value);
  const resolvedDisabledKeys = disabledKeys ?? (hasAllOption && value.includes('All') ? allOtherKeys : []);

  return (
    <TmdxSelect
      {...props}
      items={items}
      variant="bordered"
      isMultiline
      selectionMode="multiple"
      placeholder="Choose options"
      labelPlacement="outside"
      isInvalid={isInvalid}
      isDisabled={isDisabled}
      errorMessage={errorMessage}
      selectedKeys={value}
      disabledKeys={resolvedDisabledKeys}
      onSelectionChange={onSelectionChange}
      searchValue={searchValue}
      onSearchValue={onSearchValue}
      renderValue={(selectedItems) => <CoverageRenderValue items={selectedItems} onRemove={onRemove} />}
    >
      {(item) => <SelectItem key={item.value}>{item.name}</SelectItem>}
    </TmdxSelect>
  );
};
